"use client";

import NewsletterSignup from "./NewsletterSignup";

interface NewsletterBannerProps {
  heading?: {
    gold: string;
    pink: string;
  };
  description?: string;
  className?: string;
}

export default function NewsletterBanner({
  heading = { gold: "Join", pink: "Early Adopters" },
  description = "Be first to know when we launch and get the latest updates.",
  className = "",
}: NewsletterBannerProps) {
  return (
    <div className={`bg-gradient-to-r from-(--purple) via-purple-800 to-(--purple) py-12 lg:py-16 ${className}`}>
      <div className="max-w-4xl mx-auto px-6 md:px-8 xl:px-10">
        <div className="text-center mb-6">
          <h2 className="font-['Font-Bold'] text-2xl md:text-3xl mb-2">
            <span className="text-(--gold)">{heading.gold}</span>{" "}
            <span className="text-(--brand)">{heading.pink}</span>
          </h2>
          <p className="text-white/90">{description}</p>
        </div>
        <div className="max-w-xl mx-auto">
          <NewsletterSignup variant="inline" />
        </div>
      </div>
    </div>
  );
}
